/* tslint:disable */
/* eslint-disable */
/**
 * Riders API
 * Internal Riders TV API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetRiderTabs200ResponseTabsInner } from './GetRiderTabs200ResponseTabsInner';
import {
    GetRiderTabs200ResponseTabsInnerFromJSON,
    GetRiderTabs200ResponseTabsInnerFromJSONTyped,
    GetRiderTabs200ResponseTabsInnerToJSON,
    GetRiderTabs200ResponseTabsInnerToJSONTyped,
} from './GetRiderTabs200ResponseTabsInner';

/**
 * 
 * @export
 * @interface GetRiderTabs200Response
 */
export interface GetRiderTabs200Response {
    /**
     * 
     * @type {Array<GetRiderTabs200ResponseTabsInner>}
     * @memberof GetRiderTabs200Response
     */
    tabs: Array<GetRiderTabs200ResponseTabsInner>;
    /**
     * 
     * @type {number}
     * @memberof GetRiderTabs200Response
     */
    currentEventId: number;
}

/**
 * Check if a given object implements the GetRiderTabs200Response interface.
 */
export function instanceOfGetRiderTabs200Response(value: object): value is GetRiderTabs200Response {
    if (!('tabs' in value) || value['tabs'] === undefined) return false;
    if (!('currentEventId' in value) || value['currentEventId'] === undefined) return false;
    return true;
}

export function GetRiderTabs200ResponseFromJSON(json: any): GetRiderTabs200Response {
    return GetRiderTabs200ResponseFromJSONTyped(json, false);
}

export function GetRiderTabs200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetRiderTabs200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'tabs': ((json['tabs'] as Array<any>).map(GetRiderTabs200ResponseTabsInnerFromJSON)),
        'currentEventId': json['currentEventId'],
    };
}

export function GetRiderTabs200ResponseToJSON(json: any): GetRiderTabs200Response {
    return GetRiderTabs200ResponseToJSONTyped(json, false);
}

export function GetRiderTabs200ResponseToJSONTyped(value?: GetRiderTabs200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tabs': ((value['tabs'] as Array<any>).map(GetRiderTabs200ResponseTabsInnerToJSON)),
        'currentEventId': value['currentEventId'],
    };
}

